// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__oPYFr","notes":"Notes_notes__1PVgi"};